// extracted by mini-css-extract-plugin
module.exports = {"container":"_35_7NvCVApjRwwnxd4tftz"};